<template>
  <div class="searchable-item-list d-flex flex-column">
    <div class="border-bottom">
      <el-input
        :value="query"
        prefix-icon="el-icon-search"
        class="query-input"
        placeholder="ค้นหารายการ"
        clearable
        @input="handleChangeQuery"
      ></el-input>
    </div>
    <div class="list-body">
      <div v-if="noResult" class="empty">{{ emptyText }}</div>
      <item-selector-option
        v-for="item in selectableItems"
        :key="item.id"
        v-bind="item"
        :can-select="canSelect"
        class="selected-item"
        @select="handleSelectItem(item.id)"
      ></item-selector-option>
    </div>
    <div :class="loadingClassList" class="loading-indicator">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui"
import ItemSelectorOption from "./ItemSelectorOption"

export default {
  components: {
    ItemSelectorOption,
    "el-input": Input,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    disabled: {
      type: null,
      default: undefined,
    },
    query: {
      type: null,
      default: undefined,
    },
    isLoading: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {}
  },
  computed: {
    selectableItems() {
      return this.value
    },
    canSelect() {
      return !this.disabled
    },
    noResult() {
      return this.value.length === 0
    },
    isEmpty() {
      return this.value.length === 0
    },
    emptyText() {
      if (this.isEmpty) {
        return "ไม่มีรายการ"
      }

      return "ไม่พบรายการที่ค้นหา"
    },
    loadingClassList() {
      if (this.isLoading) {
        return "active"
      }

      return ""
    },
  },
  methods: {
    handleSelectItem(itemId) {
      this.$emit("select", itemId)
    },
    handleChangeQuery(value) {
      this.$emit("queryChange", value)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.searchable-item-list {
  position: relative;

  border: $border;
  border-top: 0;
  border-left: 0;

  overflow: auto;

  .el-input__inner {
    border: 0;
    height: 43px;
  }

  > .list-body {
    overflow: auto;
  }

  > .list-body > .empty {
    padding: 20px 0;
    text-align: center;
  }

  .loading-indicator {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 43px;

    border-bottom-right-radius: $border-radius;

    background: rgba(255, 255, 255, 0.7);

    text-align: center;
    padding: $space;

    &.active {
      display: block;
    }
  }
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid $primary-color;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: $primary-color transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
